import React, { memo } from "react";

const ExpandIcon: React.FC = memo(() => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.704 12.0471H16.1201L16.1059 9.11964L13.1785 12.0471L12.0471 10.9157L14.9745 7.98827L12.0471 7.97413L12.0471 6.39021H17.704V12.0471ZM12.0471 17.7039H6.39026V12.0471L7.97418 12.0471L7.98832 14.9745L10.9157 12.0471L12.0471 13.1784L9.1197 16.1059L12.0471 16.12L12.0471 17.7039Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ExpandIcon };
